import { Component, Input } from 'ng-metadata/core';
import * as angular from 'angular';
import './address.scss';
import { MediaSourceAddress } from '../media-source-document.model';

/**
 * @ngdoc directive
 * @name mwMediaSourceDocumentAddress
 * @module mw.components.contentDocuments
 *
 * @param {object} [address] - Address Object (MediaSourceDocumentAddress)
 *
 * @description
 * `<mw-media-source-document-address>` is a component used to display the primary address.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

const template = `
    <span
        ng-if="::$ctrl.address.city"
        class="mw-media-source-document-address"
        ng-bind-html="::$ctrl.address.city + ', ' + $ctrl.address.stateOrProvince + ' • ' + $ctrl.address.country">
    </span>
    <span
        ng-if="::!$ctrl.address.city && $ctrl.address.country"
        class="mw-media-source-document-address"
        ng-bind-html="::$ctrl.address.country">
    </span>
`;

@Component({
    selector: 'mw-media-source-document-address',
    template: template,
})

export class MediaSourceDocumentAddressComponent {
    @Input('<') address: MediaSourceAddress;
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/address/address.component.ts